/**
 * Texture usage.
 */
export enum TextureUsage {
  /** The content of the texture is intended to be specified once.  */
  Static,
  /** The content of the texture is intended to be updated frequently, with better performance. */
  Dynamic
}
